import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, Trash2, UserPlus, Crown } from "lucide-react";
import { api } from "../../lib/api";

export const AdminsTab = () => {
  const [admins, setAdmins] = useState(null);
  const [email, setEmail] = useState("");
  const [adding, setAdding] = useState(false);

  const load = () => api("/admin/admins").then(setAdmins).catch((e) => toast.error(e.message));
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!email.trim()) return;
    setAdding(true);
    try {
      await api("/admin/admins", { method: "POST", body: { email: email.trim() } });
      toast.success(`${email.trim()} è ora amministratore.`);
      setEmail("");
      load();
    } catch (e) {
      toast.error(e.message);
    } finally {
      setAdding(false);
    }
  };

  const del = async (em) => {
    if (!window.confirm(`Rimuovere ${em} dagli amministratori?`)) return;
    try {
      await api(`/admin/admins/${encodeURIComponent(em)}`, { method: "DELETE" });
      toast.success("Amministratore rimosso.");
      load();
    } catch (e) {
      toast.error(e.message);
    }
  };

  if (!admins) return <Loader2 className="animate-spin text-forest-glow mx-auto" size={28} />;

  return (
    <div data-testid="admin-admins" className="max-w-xl">
      <p className="text-sm text-cement border border-steel bg-card px-5 py-4 mb-6">
        Gli amministratori accedono con Google e possono gestire tutto il sito. Solo il proprietario può aggiungere o rimuovere email.
      </p>
      <div className="space-y-3 mb-8">
        {admins.map((a) => (
          <div key={a.email} data-testid={`admin-row-${a.email}`} className="flex items-center justify-between bg-card border border-steel px-5 py-4">
            <p className="text-sm text-white flex items-center gap-2.5">
              {a.email}
              {a.owner && <span className="inline-flex items-center gap-1 text-[10px] font-semibold uppercase tracking-wider text-forest-glow"><Crown size={12} /> Proprietario</span>}
            </p>
            {!a.owner && (
              <button data-testid={`admin-remove-${a.email}`} onClick={() => del(a.email)} aria-label={`Rimuovi ${a.email}`} className="w-9 h-9 flex items-center justify-center border border-steel text-metal hover:border-red-500 hover:text-red-400 transition-colors">
                <Trash2 size={14} />
              </button>
            )}
          </div>
        ))}
      </div>
      <div className="flex gap-3">
        <input data-testid="admin-new-email" type="email" className="field-input flex-1" placeholder="email@esempio.it" value={email} onChange={(e) => setEmail(e.target.value)} onKeyDown={(e) => e.key === "Enter" && add()} />
        <button data-testid="admin-add-button" onClick={add} disabled={adding || !email.trim()} className="btn-primary !px-5 disabled:opacity-60">
          {adding ? <Loader2 size={15} className="animate-spin" /> : <UserPlus size={15} />} Aggiungi
        </button>
      </div>
    </div>
  );
};
